export enum LeaveQueueCompletionBehavior {
  Reload = 'reload',
  TeamingLogoutNotice = 'teamingLogoutNotice',
}
